import React from 'react'

import './Skeleton.css'

export function Skeleton({ width ='100%', height = 8 , circle , radius, visible , className}) {

    let customClassName = ['skeleton-root'];
    if(className) customClassName.push(className)
    if(circle) customClassName.push('skeleton-circle')
    if(radius && ['sm' , 'md' , 'lg'].includes(radius)) customClassName.push(`skeleton-radius-${radius}`)
    if(visible) customClassName.push('skeleton-visible')

    customClassName = customClassName.join(' ')

    const skeletonCustomStyle = {
        skeleton_root : {
            width : (typeof width === Number && width > 0 ) ? `${width}px` : width ,
            height : (typeof height === Number && height > 0 ) ? `${height}px` : height ,

        }
    }

    return (
        <div className={customClassName} style={skeletonCustomStyle.skeleton_root}></div>
    )
}
